'use client';

import React from 'react';
import Link from 'next/link';
import {
  getLanguageSwitchMeta,
  Locale,
} from '../ssv-metting/i18n/config';
import { LanguageSwitchButton } from '../language-switch-button';
import { Logo } from '../logo';
import enLogo from '../logo/images/en-logo.png';

interface LoginPageShellProps {
  currentLang: Locale;
  children: React.ReactNode;
  hero?: React.ReactNode;
  className?: string;
  logoClickable?: boolean;
}

export function LoginPageShell({
  currentLang,
  children,
  hero,
  className = '',
  logoClickable = true,
}: LoginPageShellProps) {
  const { targetLang, langLabel } = getLanguageSwitchMeta(currentLang);

  const logoElement = (
    <Logo
      type="white"
      src={currentLang === 'en' ? enLogo : undefined}
      className="h-[29px] w-[120.5px] object-contain"
    />
  );

  return (
    <div
      className={`relative min-h-screen overflow-hidden flex flex-col ${className}`}
    >
      <header className="relative z-20 h-14 border-b border-black/10 bg-white/60 shadow-[0_4px_24px_rgba(15,23,42,0.04)] backdrop-blur-[20px]">
        <div className="flex h-full w-full items-center justify-between px-6">
          {logoClickable ? (
            <Link href="/" className="flex items-center px-[8px] py-[4px]">
              {logoElement}
            </Link>
          ) : (
            <div className="flex items-center px-[8px] py-[4px]">
              {logoElement}
            </div>
          )}
          <LanguageSwitchButton
            targetLang={targetLang}
            className="inline-flex items-center gap-1 rounded-[32px] border border-[#2C2C2C] bg-white/40 px-3 py-1 text-sm leading-[22px] text-black/90 transition-colors hover:bg-white/70"
          >
            <GlobeIcon />
            <span>{langLabel}</span>
          </LanguageSwitchButton>
        </div>
      </header>
      <main className="flex-1 relative z-10 flex justify-center items-center gap-[176px]">
        <div className="shrink-0">{children}</div>
        {hero}
      </main>
    </div>
  );
}

function GlobeIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      className="h-5 w-5 text-black/90"
      fill="none"
    >
      <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M3 10h14M10 3c2.2 2.1 3.4 4.48 3.4 7S12.2 14.9 10 17M10 3C7.8 5.1 6.6 7.48 6.6 10S7.8 14.9 10 17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
